export default __webpack_public_path__ + "532506dff5e7df7009a4612e0cc3fcfb.woff";